import check from "../../../assets/selectAccount.png";
import { useTranslation } from "react-i18next";
import FeedBack from "../../../components/feedback";

function RequestLoan() {
  const { t } = useTranslation();

  return (
    <article>
      <h1 className="text-xl md:text-2xl font-bold dark:text-secondaryGreen">
        {t("helpCenter.sidebar.How do I request a loan in the group?")}
      </h1>
      <div className="w-full h-[1px] bg-[#eff2f5] dark:bg-[#303032] mt-4 "></div>
      <section className="mt-8">
        <p className="mb-2">
          <span className="font-semibold">Step 1: </span>
          {t("helpCenter.Ikimina.loanRequest.step1")}
        </p>
        <p className="mb-2">
          <span className="font-semibold">Step 2: </span>
          {t("helpCenter.Ikimina.loanRequest.step2.part1")}
          <br />
          {t("helpCenter.Ikimina.loanRequest.step2.part2")}
        </p>
        <p className="mb-2">
          <span className="font-semibold">Step 3: </span>
          {t("helpCenter.Ikimina.loanRequest.step3")}
        </p>
        <p className="mb-2">
          <span className="font-semibold">Step 4: </span>
          {t("helpCenter.Ikimina.loanRequest.step4.part1")}
          <span className="text-blue-500">
            {t("helpCenter.Ikimina.loanRequest.step4.part2")}
          </span>
          {t("helpCenter.Ikimina.loanRequest.step4.part3")}
        </p>
        <p className="mb-2">
          <span className="font-semibold">Step 5: </span>
          {t("helpCenter.Ikimina.loanRequest.step6")}
        </p>

        <p className="mb-2">
          <span className="font-semibold">Step 6: </span>
          {t("helpCenter.Ikimina.loanRequest.step7")}
          <br /> <span className="font-semibold">Note: </span>{" "}
          {t("helpCenter.Ikimina.loanRequest.note.part1")}
          <img src={check} alt="icon" className="inline-flex w-[160px]" />
          {t("helpCenter.Ikimina.loanRequest.note.part2")}
        </p>
        <p className="mb-2">
          <span className="font-semibold">Step 7: </span>
          {t("helpCenter.Ikimina.loanRequest.step5")}
        </p>
        <p>
          <span className="font-semibold">Step 8: </span>
          {t("helpCenter.Ikimina.loanRequest.step8")}
        </p>
      </section>
      <FeedBack />
    </article>
  );
}

export default RequestLoan;
